export default __webpack_public_path__ + "static/media/shoe.5dcbe6d1.jpg";